<template>
    <div class="operationReportSearch">
        <Row :gutter="4">
            <Col span="4">
                <Input search v-model="company" :placeholder="$t('MCM.automaticalMaintenanceReport.companyName')" @on-search="searchCompany()"/>
            </Col>
            <Col span="4">
                <Input search v-model="accountId" :placeholder="$t('MCM.automaticalMaintenanceReport.account')" @on-search="searchAccountId()"/>
            </Col>
            <Col span="4">
                <DatePicker type="month" :placeholder="$t('MCM.automaticalMaintenanceReport.month')" v-model="yearMonth" @on-change="searchYearMonth($event)" style="width:100%;"></DatePicker>
            </Col>
            <Col span="6">
                <add-operation-report></add-operation-report>
            </Col>
        </Row>
    </div>
</template>
<script>
    import AddOperationReport from '../operation_report/AddOperationReport'
    import TableOperationReport from '../operation_report/TableOperationReport'
    var tableOperationReport = TableOperationReport;
    export default {
        name: 'OperationReportSearch',
        components: {
            AddOperationReport
        },
    data () {
        return {
            company:'',
            accountId:'',
            yearMonth:''
        }
    },
    methods: {
        // 按公司筛选
        searchCompany: function(){
            eventBus.$emit('company', this.company);
            tableOperationReport.methods.showAll();
        },
        // 按账号筛选
        searchAccountId: function(){
            eventBus.$emit('accountId', this.accountId);
            tableOperationReport.methods.showAll();
        },
        // 按年月筛选
        searchYearMonth: function($event){
            this.yearMonth=$event;
            eventBus.$emit('yearMonth', this.yearMonth);
            tableOperationReport.methods.showAll();
        }
    }
}
</script>
<style scoped>
    .operationReportSearch
    {
        padding: 4px 0px 15px 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/operation_kpi_configuration_management/operation_report/OperationReportSearch.vue